import { useContext } from 'react';
import { Sidebar, Segment } from 'semantic-ui-react';
import { SidebarContext } from '../../../core/SidebarComponent';
import { PrettyProjectPage } from '../../sidebars/prettyProjectPage/PrettyProjectPage';
import './WelcomePageSidebar.scss';

export const WelcomePageSidebar = () => {
    const { sidebarProjectInfoObj, sidebarVisible, setSidebarVisible } = useContext(SidebarContext);

    return (

        <div className="welcome-page-sidebar">
            <Sidebar
                as={Segment}
                animation='overlay'
                onHide={() => setSidebarVisible(false)}
                vertical
                visible={sidebarVisible}
                width='wide'
            >
                {sidebarProjectInfoObj &&
                    <PrettyProjectPage showEditButton={false} />
                }
            </Sidebar>
        </div>
    )
}
